import { LocaleKeys } from '../../../../locale/translation-types'

export enum DiplomaEnum {
  BAFA = 'BAFA',
  BAFD = 'BAFD',
  PSC1_AFPS = 'PSC1_AFPS',
  SB = 'SB',
  AGREGATION = 'AGREGATION',
  CAPES = 'CAPES',
  PLP2 = 'PLP2',
  MASTER = 'MASTER',
  LICENCE = 'LICENCE',
  TEFL_CELTA = 'TEFL_CELTA',
  OTHER = 'OTHER'
}

export const diplomaEnumMapping: Record<DiplomaEnum, LocaleKeys> = {
  [DiplomaEnum.LICENCE]: 'diploma.enum.LICENCE',
  [DiplomaEnum.BAFA]: 'diploma.enum.BAFA',
  [DiplomaEnum.MASTER]: 'diploma.enum.MASTER',
  [DiplomaEnum.BAFD]: 'diploma.enum.BAFD',
  [DiplomaEnum.CAPES]: 'diploma.enum.CAPES',
  [DiplomaEnum.PSC1_AFPS]: 'diploma.enum.PSC1_AFPS',
  [DiplomaEnum.PLP2]: 'diploma.enum.PLP2',
  [DiplomaEnum.SB]: 'diploma.enum.SB',
  [DiplomaEnum.AGREGATION]: 'diploma.enum.AGREGATION',
  [DiplomaEnum.TEFL_CELTA]: 'diploma.enum.TEFL_CELTA',
  [DiplomaEnum.OTHER]: 'diploma.enum.OTHER'
}

export const reverseDiplomaEnumMapping: Record<string, DiplomaEnum> = {
  Licence: DiplomaEnum.LICENCE,
  BAFA: DiplomaEnum.BAFA,
  Master: DiplomaEnum.MASTER,
  BAFD: DiplomaEnum.BAFD,
  CAPES: DiplomaEnum.CAPES,
  PSC1_AFPS: DiplomaEnum.PSC1_AFPS,
  PLP2: DiplomaEnum.PLP2,
  SB: DiplomaEnum.SB,
  Agrégation: DiplomaEnum.AGREGATION,
  TEFL_CELTA: DiplomaEnum.TEFL_CELTA,
  Autre: DiplomaEnum.OTHER
}
